import { render } from "./FuneralInvitationEditPage.vue?vue&type=template&id=03f83e70&lang=true"
import script from "./FuneralInvitationEditPage.vue?vue&type=script&lang=js"
export * from "./FuneralInvitationEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__